import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Router } from '@angular/router';
import { DailyDollarRateService } from "src/app/shared/services/dailydollarrate.service";
import { AdminService } from "src/app/shared/services/admin.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { TopbarComponent } from "../../shared/components/topbar/topbar.component";
import { SidebarComponent } from "../../shared/components/sidebar/sidebar.component";
import { BottombarComponent } from "../../shared/components/bottombar/bottombar.component";
import { EditDollarRateModalComponent } from "../edit-dollar-rate-modal/edit-dollar-rate-modal.component";

@Component({
    selector: "app-dollar-rate-details",
    templateUrl: "./dollar-rate-details.component.html",
    styleUrls: ["./dollar-rate-details.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent,
        EditDollarRateModalComponent,
    ]
})
export class DollarRateDetailsComponent implements OnInit {
  dailyExchangeDetails;
  id;
  details;
  clicked;
  data;
  deleteLoading: boolean = false;
  response:any;
  config;
  page = 1;
  dailyRates;
  constructor(
    private dailyDollarRateService: DailyDollarRateService,
    private route: ActivatedRoute,
    private adminService: AdminService,
    private toastrService: ToastrService,
     private router: Router
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.id = params.get("id");
      this.getAdminDetails();
      this.getDailyExchangeRate(this.id);
    });
  }

  getDailyExchangeRate(id) {
    this.dailyDollarRateService.getDetails(id).subscribe(
      // data => console.log(data)
      (data) => {
        this.dailyExchangeDetails = data;
      }
    );
  }

  getAdminDetails() {
    this.adminService.getDetails().subscribe((data) => {
      this.details = data[0];
    });
  }

  postApproveRate(approval) {
    this.clicked = true;
    const dataToSubmit = {
      id: this.id,
      adminId: this.details.id,
      status: approval,
    };
    this.dailyDollarRateService.approveRate(dataToSubmit).subscribe((data) => {
      this.toastrService.success(data.message);
      this.getDailyExchangeRate(this.id);
    });
    this.clicked = false;
  }

deleteRate() {
  this.deleteLoading = true;
  this.dailyDollarRateService.deleteRate(this.id).subscribe(
    (data) => {
      this.response = data;

      if (this.response.status) {
        this.toastrService.success(this.response.message);

        // Redirect to /dollar-rate after successful delete
        this.router.navigate(['/dollar-rate']);
      } else {
        this.toastrService.error(this.response.message);
      }
    },
    (error: any) => {
      if (error.status === 404) {
        this.toastrService.error('An Unexpected Error just occurred');
      } else if (error.status === 422) {
        this.toastrService.error('Unprocessable Entity');
      } else {
        this.toastrService.error(error.statusText || 'Something went wrong');
      }

      console.error('Delete failed:', error);
    }
  );
  this.deleteLoading = false;
}


editRate() {
    this.router.navigate([`/dollar-rate/edit/${this.id}`]);
  }

  getDollarRates(page = 1) {
      // this.clicked = true;
      this.dailyDollarRateService.getAllDailyRates(page).subscribe(
        response => {
        this.dailyRates = response.data
         this.config = {
          itemsPerPage: 10,
          currentPage: this.page,
          totalItems: response.total
        };
          //            
        },
    );
    }
}
